import { usePublishSimulatorGate } from '../hooks/use-publish-simulator-gate';

/*
 * Tells the embedded Ember app whether Hydra's simulator gate is open. Mounted outside the gated
 * dock, so a closed gate is published too and Ember never acts on entries Hydra ignores.
 */
export function SimulatorGatePublisher() {
  usePublishSimulatorGate();
  return null;
}
